import { getFromAPI, wrongParams } from "./utils";
const API = process.env.REACT_APP_API_URL;

/** + */
export const getAutocompleteFromAPI = async ({ searchText }) => {
    /** Check required parameters and return errors if any...*/
    if (!searchText) return wrongParams("searchText");

    /** ...else request API */
    const URL = `${API}/SVS/search/${searchText}`;
    const DATA = await getFromAPI(URL);

    if (DATA.message?.type === "Error") return DATA;

    // const ZITs = DATA.filter((d) => d.mpozn_kod === "5" && d.nazwa_dod === "miasto na prawach powiatu")
    //     .map((d) => ({ ...d, is_zit: true }))
    //     .sort((a, b) => a.nazwa.localeCompare(b.nazwa));
    return [
        ...DATA,
        // ...ZITs
    ];

    // return DATA;
};

/** + */
export const getBasicDataFromAPI = async ({ terrID }) => {
    /** Check required parameters and return errors if any...*/
    if (!terrID) return wrongParams("terrID");
    /** ...else request API */
    const URL = `${API}/SVS/getBasicInfo/${terrID}`;
    return await getFromAPI(URL);
};

/** + */
export const getSectionsDataFromAPI = async ({ terrID }) => {
    /** Check required parameters and return errors if any...*/
    if (!terrID) return wrongParams("terrID");
    /** ...else request API */
    const URL = `${API}/SVS/getSectionsData/${terrID}`;
    return await getFromAPI(URL);
};

export const getAreasFromAPI = async ({ terrID }) => {
    /** Check required parameters and return errors if any...*/
    if (!terrID) return wrongParams("terrID");
    /** ...else request API */
    const URL = `${API}/SVS/getAreas/${terrID}`;
    return await getFromAPI(URL);
};

export const getTableDataFromAPI = async ({ terrID, areaID }) => {
    /** Check required parameters and return errors if any...*/
    if (!terrID) return wrongParams("terrID");
    if (!areaID) return wrongParams("areaID");
    /** ...else request API */
    const URL = `${API}/SVS/getTable/${terrID}/${areaID}`;
    return await getFromAPI(URL);
};

/** + */
export const getUnitsTreeFromAPI = async () => {
    const URL = `${API}/SVS/getUnitsTree`;
    const DATA = await getFromAPI(URL);

    if (DATA.message?.type === "Error") return DATA;

    // const ZITs = DATA.filter((d) => d.mpozn_kod === "5" && d.nazwa_dod === "miasto na prawach powiatu")
    //     .map((d) => ({ ...d, is_zit: true }))
    //     .sort((a, b) => a.nazwa.localeCompare(b.nazwa));
    return [
        ...DATA.filter((d) => !d.czy_portret || d.czy_portret === "T").map((d) => {
            const findItemN = DATA.find((f) => f.czy_portret === "N" && f.id_teryt === d.id_teryt) || {};
            return {
                ...d,
                ...findItemN,
            };
        }),
        // ...ZITs,
    ];
    //czy_portret
};

/** + */
export const getBarChartDataFromAPI = async ({ terrID, indicatorID, year }) => {
    const hasWrongParams = [];
    /** Check required parameters...*/
    if (!terrID) hasWrongParams.push("terrID");
    if (!indicatorID) hasWrongParams.push("indicatorID");

    /** ...else request API */
    const URL = `${API}/SVS/getBarsChart/${terrID}/${indicatorID}`;
    return await getFromAPI(URL);
};

/** + */
export const getLineChartDataFromAPI = async ({ indicatorID, terrID }) => {
    const hasWrongParams = [];
    /** Check required parameters...*/
    if (!terrID) hasWrongParams.push("terrID");
    if (!indicatorID) hasWrongParams.push("indicatorID");

    /** ...else request API */
    const URL = `${API}/SVS/getLineChart/${indicatorID}/${terrID}`;
    return await getFromAPI(URL);
};

/** + */
export const getRankChartDataFromAPI = async ({ terrID, indicatorID }) => {
    const hasWrongParams = [];
    /** Check required parameters...*/
    if (!terrID) hasWrongParams.push("terrID");
    if (!indicatorID) hasWrongParams.push("indicatorID");

    /** ...else request API */
    const URL = `${API}/SVS/getRankChartData/${terrID}/${indicatorID}`;
    return await getFromAPI(URL);
};

/** + */
export const getRankLokChartDataFromAPI = async ({ terrID, indicatorID, type, sort }) => {
    const hasWrongParams = [];
    /** Check required parameters...*/
    if (!terrID) hasWrongParams.push("terrID");
    if (!indicatorID) hasWrongParams.push("indicatorID");
    if (!type) hasWrongParams.push("type");
    if (!sort) hasWrongParams.push("sort");

    /** ...else request API */
    const URL = `${API}/SVS/getRankLokChartData/${terrID}/${indicatorID}/${type}/${sort}`;
    return await getFromAPI(URL);
};

/** + */
export const getPineDataFromAPI = async ({ terrID, lang }) => {
    /** Check required parameters and return errors if any...*/
    let isPl = true;
    if (!terrID) return wrongParams("terrID");
    if (document.documentElement.lang === "en") {
        isPl = false;
    }
    /** ...else request API */
    const URL = `${API}/SVS/getPineData/${terrID}?czy_pl=${lang}`;
    return await getFromAPI(URL);
};

export const getChartFromAPI = async ({ chartID, terrID, lang }) => {
    /** Check required parameters and return errors if any...*/
    if (!terrID) return wrongParams("terrID");
    if (!chartID) return wrongParams("chartID");

    /** ...else request API */
    const URL = `${API}/SVS/getChartById/${chartID}/${terrID}/${lang}`;
    return await getFromAPI(URL);
};

/** + */
export const getUnitByIdFromAPI = async ({ terrID }) => {
    /** Check required parameters and return errors if any...*/
    if (!terrID) return wrongParams("terrID");
    /** ...else request API */
    const URL = `${API}/SVS/getUnitById/${terrID}`;
    return await getFromAPI(URL);
};

/** deprecated */
export const getMapDataFromAPI = async ({ terrID, year, indicatorID }) => {
    return {
        message: {
            type: "Error",
            text: "API deprecated",
        },
    };
    // const API_URL = `${API}/SVS/getMapData/${terrID}/${year}/${indicatorID}`;
    // const DATA = await fetch(API_URL).then(async (response) => {
    //     let result;
    //     try {
    //         result = await response.json();
    //     } catch (e) {
    //         result = {
    //             message: response.statusText,
    //             errcode: response.status,
    //         };
    //     }
    //     if (!response.ok) {
    //         result = {
    //             ...result,
    //             error: true,
    //         };
    //     }
    //     return result;
    // });
    // return DATA;
};

export const getIndicatorByIdFromAPI = async ({ terrID, year, indicatorID }) => {
    const API_URL = `${API}/SVS/getIndicatorById/${terrID}/${year}/${indicatorID}`;
    const DATA = await fetch(API_URL).then(async (response) => {
        let result;
        try {
            result = await response.json();
        } catch (e) {
            result = {
                message: response.statusText,
                errcode: response.status,
            };
        }
        if (!response.ok) {
            result = {
                ...result,
                error: true,
            };
        }
        return result;
    });
    return DATA;
};

export const getSearchIndicatorFromApi = async ({ searchText, terrId, lang = "PL" }) => {
    const API_URL = `${API}/SVS/getSearchIndicator/${terrId}/${searchText}?jezyk=${lang}`;
    const DATA = await fetch(API_URL).then(async (response) => {
        let result;
        try {
            result = await response.json();
            result = result.map((option) => {
                const firstLetter = option.nazwa[0].toUpperCase();
                return {
                    firstLetter: /[0-9]/.test(firstLetter) ? firstLetter + "..." : firstLetter,
                    ...option,
                };
            });
        } catch (e) {
            result = {
                message: result?.message || response.statusText,
                errcode: result?.errcode || response.status,
                error: true,
            };
        }
        if (!response.ok) {
            result = {
                ...result,
                error: true,
            };
        }
        return result;
    });
    return DATA;
};
